import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-800 text-gray-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-lg font-semibold mb-2">KSL - Engineering the future of technology</p>
        <p>&copy; {new Date().getFullYear()} Kornhill Services Ltd. All rights reserved.</p>
        <p className="mt-2 text-sm">
          <a href="#" onClick={e => e.preventDefault()} className="hover:text-white">Privacy Policy</a> |
          <a href="#" onClick={e => e.preventDefault()} className="hover:text-white">Terms of Service</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer; 